import userService from "../../../services/user.service";

async function getDoctors({ cityId }) {
  try {
    const payload = {
      pageNumber: -1,
      pageSize: 0,
      textSearch: "",
      cityId,
      practiceLocationId: 0,
    };
    const response = await userService.getDoctors(payload);
    if (response.data && response.data.status) {
      console.log(response.data.result);
      return JSON.stringify(response.data.result);
    } else {
      return (
        JSON.stringify(response.data.message) || "Failed to fetch doctors."
      );
    }
  } catch (error) {
    const errorMessage =
      (error.response && error.response.data && error.response.data.message) ||
      error.message ||
      "An unexpected error occurred.";
    console.error("Error fetching doctors:", errorMessage);
    return JSON.stringify(errorMessage);
  }
}

async function getDoctorsByPracticeLocation({ practiceLocationId }) {
  console.log(practiceLocationId);
  try {
    const payload = {
      practiceLocationId: practiceLocationId,
      pageNumber: -1,
      pageSize: 0,
      textSearch: "",
    };
    console.log(payload);
    const response = await userService.getDoctorsByPracticeLocation(payload);
    if (response.data && response.data.status) {
      console.log(response.data.result);
      return JSON.stringify(response.data.result);
    } else {
      return (
        JSON.stringify(response.data.message) ||
        "Failed to fetch doctors by practice location."
      );
    }
  } catch (error) {
    const errorMessage =
      (error.response && error.response.data && error.response.data.message) ||
      error.message ||
      "An unexpected error occurred.";
    console.error("Error fetching doctors by practice location:", errorMessage);
    return JSON.stringify(errorMessage);
  }
}

async function getDoctorsWithCustomer({ rankId }) {
  try {
    const response = await userService.getDoctorsWithCustomer(rankId);
    if (response.data && response.data.status) {
      console.log(response.data.result);
      return JSON.stringify(response.data.result);
    } else {
      return (
        JSON.stringify(response.data.message) ||
        "Failed to fetch doctors with customer ranks."
      );
    }
  } catch (error) {
    const errorMessage =
      (error.response && error.response.data && error.response.data.message) ||
      error.message ||
      "An unexpected error occurred.";
    console.error("Error fetching doctors with customer ranks:", errorMessage);
    return JSON.stringify(errorMessage);
  }
}

// async function addDoctorToDatabase({
//   doctorName,
//   specialization,
//   cityId,
//   practiceLocationId,
//   isActive,
// }) {
//   try {
//     const payload = {
//       name: doctorName,
//       specialization,
//       cityId,
//       practiceLocationId,
//       active: isActive,
//     };
//     const response = await userService.addDoctor(payload);
//     if (response.data && response.data.status) {
//       console.log(response.data.result);
//       return JSON.stringify(response.data.result);
//     } else {
//       return JSON.stringify(response.data.message) || "Failed to add doctor.";
//     }
//   } catch (error) {
//     const errorMessage =
//       (error.response && error.response.data && error.response.data.message) ||
//       error.message ||
//       "An unexpected error occurred.";
//     console.error("Error adding doctor:", errorMessage);
//     return JSON.stringify(errorMessage);
//   }
// }

// async function updateDoctorInDatabase({
//   doctorId,
//   doctorName,
//   specialization,
//   cityId,
//   practiceLocationId,
//   isActive,
// }) {
//   try {
//     const payload = {
//       id: doctorId,
//       name: doctorName,
//       specialization,
//       cityId,
//       practiceLocationId,
//       active: isActive,
//     };
//     const response = await userService.updateDoctor(payload);
//     if (response.data && response.data.status) {
//       console.log(response.data.result);
//       return JSON.stringify(response.data.result);
//     } else {
//       return (
//         JSON.stringify(response.data.message) || "Failed to update doctor."
//       );
//     }
//   } catch (error) {
//     const errorMessage =
//       (error.response && error.response.data && error.response.data.message) ||
//       error.message ||
//       "An unexpected error occurred.";
//     console.error("Error updating doctor:", errorMessage);
//     return JSON.stringify(errorMessage);
//   }
// }

export default {
  getDoctors,
  getDoctorsByPracticeLocation,
  getDoctorsWithCustomer,
  // addDoctorToDatabase,
  // updateDoctorInDatabase,
  doctorTools: [
    {
      type: "function",
      function: {
        name: "getDoctors",
        description: "Fetch all doctors in a specific city.",
        parameters: {
          type: "object",
          properties: {
            cityId: {
              type: "string",
              description: "The unique ID of the city to fetch doctors from.",
            },
          },
          required: ["cityId"],
        },
      },
    },
    {
      type: "function",
      function: {
        name: "getDoctorsByPracticeLocation",
        description: "Fetch all doctors based on a practice location.",
        parameters: {
          type: "object",
          properties: {
            practiceLocationId: {
              type: "number",
              description: "The unique ID of the practice location.",
            },
          },
          required: ["practiceLocationId"],
        },
      },
    },
    {
      type: "function",
      function: {
        name: "getDoctorsWithCustomer",
        description: "Fetch all doctors with customer ranks.",
        parameters: {
          type: "object",
          properties: {
            rankId: {
              type: "string",
              description: "The unique rank ID to filter doctors.",
            },
          },
          required: ["rankId"],
        },
      },
    },
    // {
    //   type: "function",
    //   function: {
    //     name: "addDoctorToDatabase",
    //     description: "Add a new doctor to the database.",
    //     parameters: {
    //       type: "object",
    //       properties: {
    //         doctorName: {
    //           type: "string",
    //           description: "Name of the doctor.",
    //         },
    //         specialization: {
    //           type: "string",
    //           description: "Specialization of the doctor.",
    //         },
    //         cityId: {
    //           type: "string",
    //           description: "City ID where the doctor practices.",
    //         },
    //         practiceLocationId: {
    //           type: "string",
    //           description: "Practice location ID.",
    //         },
    //         isActive: {
    //           type: "boolean",
    //           description: "Whether the doctor is active.",
    //         },
    //       },
    //       required: [
    //         "doctorName",
    //         "specialization",
    //         "cityId",
    //         "practiceLocationId",
    //       ],
    //     },
    //   },
    // },
    // {
    //   type: "function",
    //   function: {
    //     name: "updateDoctorInDatabase",
    //     description: "Update an existing doctor's information.",
    //     parameters: {
    //       type: "object",
    //       properties: {
    //         doctorId: {
    //           type: "string",
    //           description: "The unique ID of the doctor to be updated.",
    //         },
    //         doctorName: {
    //           type: "string",
    //           description: "Updated name of the doctor.",
    //         },
    //         specialization: {
    //           type: "string",
    //           description: "Updated specialization of the doctor.",
    //         },
    //         cityId: {
    //           type: "string",
    //           description: "Updated city ID.",
    //         },
    //         practiceLocationId: {
    //           type: "string",
    //           description: "Updated practice location ID.",
    //         },
    //         isActive: {
    //           type: "boolean",
    //           description: "Updated active status of the doctor.",
    //         },
    //       },
    //       required: [
    //         "doctorId",
    //         "doctorName",
    //         "specialization",
    //         "cityId",
    //         "practiceLocationId",
    //       ],
    //     },
    //   },
    // },
  ],
};
